import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { baseUrlInterceptor } from './core/interceptors/base-url.interceptor';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#FAFAFA',
      100: '#EAEFFA',
      200: '#C2D1F1',
      300: '#9BB3E8',
      400: '#7395E0',
      500: '#080808',
      600: '#2854B5',
      700: '#234AA0',
      800: '#1A3778',
      900: '#112551',
      950: '#080808'
    },
    surface: {
      0: '#ffffff',
      50: '{slate.50}',
      100: '{slate.100}',
      200: '{slate.200}',
      300: '{slate.300}',
      400: '{slate.400}',
      500: '{slate.500}',
      600: '{slate.600}',
      700: '{slate.700}',
      800: '{slate.800}',
      900: '{slate.900}',
      950: '{slate.950}'
    }
  },
  components: {
    tabs: {
      tab: {
        activeColor: '#2854b5',
        activeBorderColor: '#2854b5',
        hoverColor: '#2854b5'
      },
      activeBar: {
        background: '#2854b5'
      }
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    MessageService,
    provideHttpClient(
      withInterceptors([baseUrlInterceptor, tokenInterceptor, errorInterceptor])
    ),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false || 'none'
        }
      }
    })
  ],
};
